export const achievementData = {
    bio : "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
    achievements : [
        {
            id : 1,
            title : 'Google Development Group',
            details : 'Working as proud member of Google Developer Group on Campus. Organize events, workshops and sessions to help developers grow their skills.',
            date : 'Aug 20, 2024',
            field : 'Development',
            fieldUrl : 'https://developers.google.com/community',
            image : 'https://raw.githubusercontent.com/shamzaovais/my-portfolio/refs/heads/main/src/assets/png/google.png'
        },
        {
            id : 2,
            title : 'AWS Certification',
            details : 'Focuses on designing and deploying scalable applications, AWS Lambda, API Gateway, and DynamoDB, enabling developers to build efficient, cost-effective systems. .',
            date : 'Aug 20, 2022',
            field : 'Cloud ',
            fieldUrl : 'https://aws.amazon.com/certification/',
            image : 'https://blog.chapimenge.com/images/blogs/aws/serverless_hua9116ec523085f22c4160b9c7e85d2b1_253719_1110x0_resize_lanczos_3.png'
        },
        {
            id : 3,
            title : 'Samsung Ai Automation',
            details : 'Focuses on developing AI-driven solutions for real-world industrial environments, building efficient and scalable systems to solve complex operational and automation challenges.',
            date : 'Aug 20, 2023',
            field : 'Automation',
            fieldUrl : 'https://news.samsung.com/global/tag/ai',
            image : 'https://images.samsung.com/is/image/samsung/assets/pk/innovation_campus/images/2024_assets/Innovation-Campus_revised-1440x810.jpg?$ORIGIN_JPG$'
        },
                {
            id : 4,
            title : 'OpenCv Image Processing',
            details : 'Image processing fundamentals, enabling development of real-time computer vision applications using efficient algorithms and practical implementations.',
            date : 'Aug 20, 2025',
            field : 'Automation',
            fieldUrl : 'https://opencv.org/',
            image : 'https://media2.dev.to/dynamic/image/width=1280,height=720,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fibibfurquv35t4mn1pt9.png'
        },
        {
            id : 5,
            title : 'Critical Infrastructure Protection',
            details : 'Focuses on protecting critical infrastructure through cybersecurity practices, risk management, and securing essential systems against evolving threats and vulnerabilities.',
            date : 'Aug 20, 2025',
            field : 'Cyber Security',
            fieldUrl : 'https://www.cisa.gov/critical-infrastructure',
            image : 'https://static.opswatacademy.com/redesign/uploads/images/courses/associate/ICIP.jpeg'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/